export const DsAccordionDefaultProps = {
    elevation: -1,
    header: '',
    summary: ''
};
